import Particles, { initParticlesEngine } from '@tsparticles/react';
import { useEffect, useMemo, useState } from 'react';

import { COLOR } from '@/config/color.config';
import { Icon } from '@iconify/react';
import { loadFull } from 'tsparticles';

const baseOptions = {
  key: 'star',
  name: 'Star',
  particles: {
    number: { value: 20, density: { enable: false } },
    color: { value: ['#7c3aed', '#bae6fd', '#a78bfa', '#93c5fd', '#0284c7', '#fafafa', '#38bdf8'] },
    shape: { type: 'star', options: { star: { sides: 4 } } },
    opacity: { value: 0.8 },
    size: { value: { min: 1, max: 4 } },
    rotate: {
      value: { min: 0, max: 360 },
      enable: true,
      direction: 'clockwise',
      animation: { enable: true, speed: 10, sync: false },
    },
    links: { enable: false },
    reduceDuplicates: true,
    move: { enable: true, center: { x: 120, y: 45 } },
  },
  interactivity: { events: {} },
  smooth: true,
  fpsLimit: 120,
  background: { color: 'transparent', size: 'cover' },
  fullScreen: { enable: false },
  detectRetina: true,
  absorbers: [{ enable: true, opacity: 0, size: { value: 1, density: 1 }, position: { x: 110, y: 45 } }],
  emitters: [
    {
      autoPlay: true,
      fill: true,
      life: { wait: true },
      rate: { quantity: 5, delay: 0.5 },
      position: { x: 110, y: 45 },
    },
  ],
};

export default function AiButton({
  children,
  icon = 'mdi:sparkles',
  className = '',
  enableParticles = true,
  ...buttonProps
}) {
  const [particleState, setParticleState] = useState('loaded');
  const [hover, setHover] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadFull(engine);
    });
  }, []);

  const particleOptions = useMemo(() => ({ ...baseOptions, autoPlay: hover }), [hover]);

  return (
    <button
      {...buttonProps}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={`group relative rounded-full p-1 text-white ${className}`}
      style={{
        background: `linear-gradient(135deg, ${COLOR.PRIMARY[600]} 0%, #2F1D4E 100%)`,
        boxShadow: `0 4px 15px rgba(47, 29, 78, 0.3)`,
      }}
    >
      <div
        className="relative flex items-center justify-center gap-2 rounded-full px-4 py-2"
        style={{
          background: `linear-gradient(135deg, ${COLOR.PRIMARY[600]} 0%, #2F1D4E 100%)`,
        }}
      >
        {icon && <Icon icon={icon} className="size-6 -translate-y-0.5 animate-sparkle" color="white" />}
        {children}
      </div>

      {enableParticles && particleState === 'ready' && (
        <Particles
          id="ai-button-particles"
          className="pointer-events-none absolute -inset-4 z-10 opacity-0 transition-opacity group-hover:opacity-100"
          particlesLoaded={() => setParticleState('ready')}
          options={particleOptions}
        />
      )}
      {enableParticles && particleState === 'loaded' && (
        <Particles
          id="ai-button-particles-loader"
          className="hidden"
          particlesLoaded={() => setParticleState('ready')}
          options={particleOptions}
        />
      )}
    </button>
  );
}
